<template>
  <div class="hello">
    <!-- Modal -->
    <div class="modal fade" id="errModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header conditions-utilisation">
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
            <div class="modal-title" style="display: block;">
              CONDITIONS D’UTILISATION DU SITE
            </div>
          </div>
          <div class="modal-body">
            <section id="cgu-section">
              <!-- CGU START -->
              <div class="h3-sub-title">Préambule</div>
              <p class="col-md-12 columns">Le présent site, entièrement géré par Orisha Adgency, est un site de dépôt et de mise en ligne de messages dans lʼespace dédié aux commerçants du programme Orisha Adgency. Les messages doivent être de type informatif concernant votre commerce (horaires, congés, menu du jour...) ou dʼauto-promotion (services et ou produits disponibles, promotions et soldes...). Lʼutilisation de lʼespace commerçant dans le programme Orisha Adgency est gratuite et exclusivement réservée aux clients Orisha. Cet espace ne peut être commercialisé ni cédé à un tiers. Le seul fait dʼutiliser le présent site implique lʼacceptation pleine et entière des conditions dʼutilisation décrites ci-dessous.</p>
              <div class="h3-sub-title">Contenu des messages diffusés dans l’espace commerçant</div>
              <p class="col-md-12">
                Nous vous remercions de respecter le règlement sur le contenu décrit ci-dessous.<br/><br/>
                <strong>Règlement sur les contenus interdits</strong><br/>
                Afin de maintenir un service de qualité, il est interdit de diffuser un message :<br/>
                <span style="display: block; padding-left: 15px;">
                - qui contient des informations personnelles concernant un individu ne souhaitant pas qu'elles apparaissent<br/>
                - qui soit mensonger*, diffamatoire, profane, haineux, abusif, pornographique, obscène ou de toute autre nature inappropriée (et laissé à notre seule discrétion)<br/>
                - qui encourage la violence ou toute conduite criminelle<br/>
                - qui dévoile des éléments de nature privée ou viole la vie privée d'une personne (inclus la publication de visages) sans son autorisation<br/>
                - qui contrevienne aux droits de propriété physique ou intellectuelle d'un tiers<br/>
                - qui propose de l'information, des produits ou des services dont la vente, la distribution ou la divulgation est sujette à régulations** ou dont la possession ou vente est illégale. Vous ne pouvez diffuser un message dont le but est de vendre des objets contrefaits, de la drogue (interdite ou sur ordonnance), tout type de médicaments, des armes à feu sans permis ou armes blanches, des organes ou parties de corps humain, des billets de loterie, du tabac, de l'alcool ou tout type de produit dangereux.<br/>
                - faisant la promotion de groupes à caractère sectaire.</span><br/><br/>
                <span style="color: var(--primary-color); font-weight: bold; font-style: italic;">Attention :</span><br/>
                * Veillez à ce que les termes que vous utilisez pour communiquer à propos dʼun produit soient bien exacts. Par exemple, vous ne pouvez pas parler de carte de crédit à propos de PCS Card car il sʼagit en réalité dʼune carte de paiement, vous seriez exposé à des poursuites pour publicité mensongère.<br/>
                ** La Loi Evin et la loi Santé qui régissent la publicité concernant l'alcool, le tabac, l'alimentation sont très contraignantes et restrictives.
              </p>
              <p class="col-md-12">
                Nous rappelons que l'ensemble des agissements susvisés constituent des infractions définies et réprimées par le code pénal français, dont la violation pourrait vous engager à des poursuites ou sanctions judiciaires, l'Equipe Orisha Adgency ne pouvant être tenue responsable du contenu de vos messages. Vous êtes responsables de vous assurer de respecter la loi qui s'applique aux biens et services que vous offrez.
              </p>
              <p class="col-md-12">
                Cette liste est non exhaustive et Orisha Adgency se réserve le droit dʼarrêter la diffusion de tout message non conforme.
              </p>
              <p class="col-md-12">
                <em><span style="color: var(--primary-color); font-weight: bold;">Information sur lʼutilisation des logos :</span> Nous vous rappelons quʼil ne vous est pas possible de faire la promotion de produits en faisant figurer les logos des marques car leur utilisation est soumise à une réglementation stricte.</em>
              </p>
              <p class="col-md-12">
                Dans le cas où un utilisateur réitère la diffusion de messages non conformes, Orisha Adgency se réserve le droit de lui interdire lʼaccès au site.
              </p>
              <div class="h3-sub-title">Responsabilité</div>
              <p class="col-md-12">
                Orisha Adgency se réserve le droit d'interrompre l'accès au site pour procéder à des opérations de maintenance et/ou de test. Orisha Adgency s'efforcera de réaliser ces opérations pour les durées les plus courtes possible et en dehors des heures de forte utilisation. La responsabilité de Orisha Adgency ne pourra en aucun cas être recherchée de ce fait.
              </p>
              <div class="h3-sub-title">Durée de diffusion</div>
              <p class="col-md-12" style="margin-bottom: 50px;">
                Vous seul gérez la durée de diffusion de vos messages, vous pouvez les actualiser aussi souvent et aussi fréquemment que vous le souhaitez.
              </p>
              <p class="col-md-12" style="margin-bottom: 100px;">DIGITAL POINT DE VENTE - Orisha Adgency – SARL au capital de 12 000€ - RCS Paris 500 248 141<br/>
                T : 01 53 09 26 80 – www.retail-shops.orisha.com/adgency</p>
              <!-- CGU END -->
            </section>
          </div>
          <div class="modal-footer">
            <button id="refuse" type="button" class="btn btn-default create-account" data-dismiss="modal">
              REFUSER
            </button>
            <button id="approve" type="button" class="btn btn-default" data-dismiss="modal">
              J'AI LU ET ACCEPTE LES CONDITIONS D'UTILISATION DU SITE&nbsp;&nbsp;&nbsp;
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="4828 932 20 14.579" style="fill: var(--secondary-color); width: 20px; height: 14px;"><path class="a" d="M24.476,11.776a.388.388,0,0,0-.274.114L10.857,25.237l-5.065-4.58a.39.39,0,0,0-.547.011l-.134.139a.382.382,0,0,0,.011.547l5.422,4.9a.4.4,0,0,0,.343.093.38.38,0,0,0,.33-.1L24.886,12.574a.386.386,0,0,0,0-.547l-.137-.137A.386.386,0,0,0,24.476,11.776Z" transform="translate(4823 920.224)"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->
    <!-- ////////////// Header Start ////////////// -->
    <app-header></app-header>
    <!-- ////////////// Header End ////////////// -->
    <button id="showModalButton" type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#errModal" style="visibility: hidden; position: absolute; top: -10000px;">
      Launch modal
    </button>
    <form id="authentMe">
      <div class="info-box">
        <svg class="info-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
        <div class="info-text">
          Merci d’entrer votre identifiant et mot de passe Orisha Commerce pour vous connecter.
        </div>
      </div>
      <div class="error-box">
        <div class="error-text">
          <ul>
            <li>Votre identifiant ou votre mot de passe est erroné.<br/>Merci de réessayer.</li>
          </ul>
        </div>
        <svg class="error-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="3179.1 1494.105 25.995 26" style="fill: var(--error-primary-color);"><path class="a" d="M30.316,5c.525.13.972.906.416,1.282L19.124,17.891c3.953,3.953,8.35,8.519,11.823,12.081.285.663-.794,1.416-1.236.761L18.1,19.124c-3.913,3.913-8.519,8.349-12.081,11.823-.663.285-1.416-.794-.761-1.236L16.871,18.1C13.233,13.842,8.521,9.586,5.047,6.023c-.285-.663.794-1.416,1.236-.761L17.89,16.871c3.858-3.858,8.5-8.306,12.024-11.791A.6.6,0,0,1,30.316,5Z" transform="translate(3174.1 1489.11)"/></svg>
      </div>
      <div class="refuse-box">
        <div class="refuse-text">
          <ul>
            <li>Vous ne pouvez pas créer d'annonces ou de publicités si vous<br/>refusez les conditions générales du site.</li>
          </ul>
        </div>
        <svg class="refuse-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="3179.1 1494.105 25.995 26" style="fill: var(--error-primary-color);"><path class="a" d="M30.316,5c.525.13.972.906.416,1.282L19.124,17.891c3.953,3.953,8.35,8.519,11.823,12.081.285.663-.794,1.416-1.236.761L18.1,19.124c-3.913,3.913-8.519,8.349-12.081,11.823-.663.285-1.416-.794-.761-1.236L16.871,18.1C13.233,13.842,8.521,9.586,5.047,6.023c-.285-.663.794-1.416,1.236-.761L17.89,16.871c3.858-3.858,8.5-8.306,12.024-11.791A.6.6,0,0,1,30.316,5Z" transform="translate(3174.1 1489.11)"/></svg>
      </div>
      <div class="form-group">
        <input id="user-name" name="user-name" type="text"  class="form-control" autocomplete="username" placeholder="Identifiant utilisateur" v-model="user_name" v-on:keydown="onSubmitEnter">
        <button class="error-reset"></button>
      </div>
      <div class="form-group">
        <input id="password" name="password" type="password" class="form-control" autocomplete="current-password" placeholder="Mot de passe" v-model="password" v-on:keydown="onSubmitEnter">
        <button class="error-reset"></button>
      </div>
      <div class="form-group">
        <div>
          <button id="submitAuth" name="submitAuth" class="btn btn-default">SE CONNECTER</button>
          <a id="forgotten-password" v-bind:href="config[env].loginUrl" target="_blank">J'ai oublié mon mot de passe</a>
        </div>
      </div>
    </form>
    <!-- Button trigger modal -->
    <button id="modalButton" type="button" style="visibility: hidden;">
      Launch modal
    </button>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'hello',
  data () {
    return {
      env: process.env.NODE_ENV,
      user_name: '',
      password: '',
      user: AppModules.getUser(),
      config: AppModules.getConfig()
    }
  },
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  mounted: function () {
    var self = this
    console.log('env', process.env.NODE_ENV)
    //
    document.querySelector('.modal-body').onscroll = function (e) {
      //
      var offset = this.scrollTop + parseInt(window.getComputedStyle(this).height)
      var height = this.scrollHeight
      //
      if (offset >= height) {
        document.querySelector('button#approve.btn-default').classList.add('cgu-button-hover')
      } else {
        document.querySelector('button#approve.btn-default').classList.remove('cgu-button-hover')
      }
    }
    //
    setTimeout(function () {
      document.querySelector('.info-box').classList.add('fullOpacity')
    }, 500)
    //
    document.querySelector('#modalButton').addEventListener('click', function (e) {
      document.querySelector('.info-box').classList.remove('fullOpacity')
      document.querySelector('.refuse-box').classList.remove('fullOpacity')
      document.querySelector('.error-box').classList.add('fullOpacity')
      Array.prototype.forEach.call(document.querySelectorAll('.form-control'), function (item) {
        item.classList.add('error')
      })
      Array.prototype.forEach.call(document.querySelectorAll('.error-reset'), function (item) {
        item.style.display = 'block'
        item.addEventListener('click', function (e) {
          self.errorReset(true)
        }, false)
      })
    }, false)
    //
    document.querySelector('.error-box-icon').addEventListener('click', function (e) {
      self.errorReset(true)
    }, false)
    //
    document.querySelector('#refuse').addEventListener('click', function (e) {
      document.querySelector('.info-box').classList.remove('fullOpacity')
      document.querySelector('.error-box').classList.remove('fullOpacity')
      document.querySelector('.refuse-box').classList.add('fullOpacity')
      Array.prototype.forEach.call(document.querySelectorAll('.error-reset'), function (item) {
        item.style.display = 'none'
        item.removeEventListener('click', self.errorReset)
      })
    })
    document.querySelector('.refuse-box-icon').addEventListener('click', function (e) {
      self.errorReset(false)
    }, false)
    //
    var domElements = {
      login: document.querySelector('input#user-name'),
      password: document.querySelector('input#password'),
      conditions_utilisation: document.querySelector('input#conditions-utilisation'),
      submit: document.querySelector('button#submitAuth'),
      connect: document.querySelector('button#connect'),
      modalButton: document.querySelector('button#modalButton'),
      showModalButton: document.querySelector('button#showModalButton'),
      errModalContent: document.querySelector('.error-text > ul'),
      approveCGU: document.querySelector('button#approve')
    }
    this.user.setDomElements(domElements, this.$router)
    return AppModules.initDb(function (err, success) {
      if (err) {
        console.log(err)
      }
      // console.log(success)
    })
  },
  methods: {
    errorReset: function (fieldReset) {
      console.log(fieldReset)
      document.querySelector('.error-box').classList.remove('fullOpacity')
      document.querySelector('.refuse-box').classList.remove('fullOpacity')
      document.querySelector('.info-box').classList.add('fullOpacity')
      Array.prototype.forEach.call(document.querySelectorAll('.form-control'), function (item) {
        item.classList.remove('error')
      })
      Array.prototype.forEach.call(document.querySelectorAll('.error-reset'), function (item) {
        item.style.display = 'none'
        item.removeEventListener('click', self.errorReset)
      })
      if (fieldReset) {
        document.querySelector('#user-name').value = ''
        document.querySelector('#password').value = ''
      }
    },
    onSubmitEnter: function () {
      if (event.keyCode === 13) {
        event.stopPropagation()
        event.preventDefault()
        document.querySelector('button#submitAuth').click()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .hello {
    /*background-image: url(../assets/images/votre-espace-2-orange.png);
    background-position: 0 50px;
    background-repeat: no-repeat;
    width: 733px;
    margin: auto;*/
  }

  #authentMe {
    width: 667px;
    height: 455px;
    position: relative;
    top: calc(50vh - (455px / 2) + 120px);
    margin: auto;
    text-align: center;
  }

  .form-group {
    width: 250px;
    margin: auto;
    position: relative;
  }

  .form-control {
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 14px;
    border: 1px solid var(--grey-third-color);
    border-radius: 4px;
    box-shadow: 0 3px 6px var(--secondary-color);
    height: 40px;
  }

  .form-control.error {
    border: 1px solid var(--error-primary-color);
    box-shadow: 0 3px 6px var(--error-secondary-color);
  }

  .error-reset {
    display: none;
    position: absolute;
    width: 16px;
    height: 16px;
    background: url(/static/images/cancel.svg) no-repeat;
    background-size: 16px 16px;
    border: none;
    left: 225px;
    top: 12px;
  }

  #user-name {
    margin-top: calc(100vh / (1080 / 55));
  }

  #password {
    margin-top: calc(100vh / (1080 / 40));
  }

  .btn-default {
    border: none;
    font-family: 'Open Sans', Arial;
    font-weight: 600;
    font-size: 14px;
    margin-top: calc(100vh / (1080 / 43));
    color: var(--secondary-color);
    background-color: var(--grey-primary-color);
    border-radius: 4px;
    width: 166px;
    height: 36px;
    position: relative;
    z-index: 1000;
  }

  .btn-default:hover {
    color: var(--secondary-color);
    background-color: var(--primary-color);
  }

  .cgu-button-hover {
    background-color: var(--primary-color);
  }

  .create-account {
    background-color: var(--secondary-color);
    color: var(--grey-eighth-color);
    text-decoration: none;
    box-sizing: border-box;
    border: 1px solid var(--grey-eighth-color);
    margin-top: calc(100vh / (1080 / 20));
    position: relative;
    z-index: 1000;
  }

  .create-account:hover {
    border: 1px solid var(--primary-color);
  }

  a#forgotten-password {
    font-family: 'Open Sans', Arial;
    font-weight: 600;
    font-size: 12px;
    color: var(--grey-eighth-color);
    display: block;
    margin-top: calc(100vh / (1080 / 30));
    position: relative;
    z-index: 1000;
    text-decoration: underline;
  }

  a#forgotten-password:hover {
    color: var(--primary-color);
  }

  /* ---------------- */

  .modal-dialog {
    width: 700px;
    position: absolute;
    margin: auto;
    top: calc(50vh - ((100vh / (1080 / 887)) / 2));
    left: calc(50vw - (700px / 2));
    /*z-index: 1100;*/
  }

  .modal-content {
    height: calc(100vh / (1080 / 887));
  }

  .modal-header {
    border: none;
    padding: 28px 20px;
    height: 136px;
  }

  .modal-body {
    border-top: 1px solid var(--secondary-color);
    border-bottom: 1px solid var(--secondary-color);
    width: calc(700px - (20px * 2));
    margin: auto;
    height: calc(100vh / (1080 / 887) - (136px + 66px));
    overflow-x: visible;
    overflow-y: auto;
  }

  .modal-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    border-radius: 15px;
    background-color: var(--secondary-color);
  }

  .modal-body::-webkit-scrollbar {
    width: 4px;
    background-color: var(--secondary-color);
  }

  .modal-body::-webkit-scrollbar-thumb {
    border-radius: 20px;
    /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
    background-color: var(--grey-primary-color);
  }

  /* -------------------- */
  .modal-footer {
    border: none;
    text-align: left;
    padding: 15px 20px;
    height: 66px;
  }

  #approve, #refuse {
    width: auto;
    text-decoration: none;
    margin: 0;
    position: relative;
    z-index: 1000;
  }

  #approve {
    float: right;
  }

  #refuse {
    /* -------------------- */
  }

  /* -------------------- */

  .modal-body p {
    text-align: justify;
  }

  p {
    text-align: center;
    font-family: 'Open Sans', Arial;
    font-weight: 400;
    font-size: 14px;
    color: var(--grey-eighth-color);
  }

</style>



// WEBPACK FOOTER //
// Hello.vue?3de7b2c9